import React from 'react';

interface BoardContextType {
  board:
    | CustomerLaneBoard
    | DriverPerformanceBoard
    | GeneralBoard
    | PerformanceBoardTypes.Board;
  reasonCodes: ReasonCode[];
  isDeletable?: boolean;
  onDeleted?: () => void;
  quickFilters: LegacySavedFilter[];
  selectedQuickFilters: LegacySavedFilter[];
  setSelectedQuickFilters: React.Dispatch<
    React.SetStateAction<LegacySavedFilter[]>
  >;
  /**
   * Filters passed to FilterPlatesProvider alongside the selected quick
   * filters which aren't toggleable (e.g. a board's data source filter)
   */
  fixedQuickFilters?: FilterInput[];
  isBoardOwner?: boolean;
}

export const toDateRange = (bonusPeriod: Period): DateRangeInput => ({
  startDate: bonusPeriod.startDate,
  endDate: bonusPeriod.endDate,
});

const BoardContext = React.createContext({} as BoardContextType);

export default BoardContext;
